<template>
  <div class="demo_loop">
    <div class="player_centre">
      <div class="player_responsive">
        <iframe
          :src="getSourceIframe"
          width="100%"
          height="100%"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen="allowfullscreen"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import * as types from "../store/video/loop";
export default {
  props: {
    type: {
      type: String,
      default: "Vue!",
    },
    plugin: {
      type: String,
      default: "simple",
    },
  },
  data() {
    return {
      loaded: false,
      query: { plugin: "simple", skin: "15" },
      standalone: {},
    };
  },
  computed: {
    getSourceIframe() {
      switch (this.type) {
        case "CAPTION_OPTIONS":
          return "https://app.empreinte.tv/embed/empreinte-motion-3jggmqze-67_340_150054cMp";
        case "INTERACTIVITY_OPTIONS":
          return "https://app.empreinte.tv/embed/frenchpolynesiamattdevir-l8bsb9dj-12qkiC7?plugin=interactivity&skin=dark";

        case "NAVIGATION_OPTIONS":
          return "https://app.empreinte.tv/embed/BigBuckBunnyNXGJH";

        default:
          return "";
      }
    },
  },
  methods: {
    readyPlayer(param) {
      var player = param;
      player.cryptedParam = this.crypttext;
      this.loaded = true;
    },
  },
  created() {
    this.query.plugin = this.plugin;
    this.standalone = types[this.type];
  },
};
</script>
<style lang="scss">
@media screen and (max-width: 736px) {
  .demo_loop {
    .player_centre {
      .player_responsive {
        width: 100%!important;
        height: 56.25vw!important;
      }
    }
  }
}
.demo_loop {
  .player_centre {
    display: flex;
    justify-content: center;
    margin-top: 1em;
    .player_responsive {
      position: relative;
      padding-top: 0;
      overflow: hidden;
      width: 60vw;
      height: 33.75vw;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      .player {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Demo.vue?0b91f184